module.exports = __webpack_public_path__ + "img/dark-s_nx.7982b0f3.jpg";